import { Pencil, Save } from 'lucide-react';
import { Button } from '@/components/Button';

interface CardEditActionsProps {
  isEditing: boolean;
  onEdit: () => void;
  onSave: () => void;
  isPending?: boolean;
  editRefusal?: string | null;
}

export function CardEditActions(props: CardEditActionsProps) {
  const { isEditing, onEdit, onSave, isPending, editRefusal } = props;
  return isEditing ? (
    <Button type="button" variant="color" icon={Save} onClick={onSave} isPending={isPending}>
      Enregistrer
    </Button>
  ) : (
    <Button
      type="button"
      icon={Pencil}
      onClick={onEdit}
      className="text-gray-600"
      disabledReason={editRefusal}
    />
  );
}
